// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2GZS_","buttons":"SendReceipts_buttons__2lUa4","email":"SendReceipts_email__3qLiv","bookApptTitle":"SendReceipts_bookApptTitle__1aCWK"};